import React, { useState } from 'react';

import { Skeleton } from '@material-ui/lab';
import { isNil } from 'ramda';

import styles from './S3ImageWrapper.module.scss';

export interface IS3ImageWrapperProps {
  className?: string;
	lightSkeleton?: boolean;
}

export const S3ImageWrapper: React.FC<IS3ImageWrapperProps> = ({
	className,
	lightSkeleton = false,
}) => {
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const wrapperClasses = [styles['s3-image-wrapper'], className];
	const skeletonClasses = [
		styles['s3-image-wrapper__skeleton'],
		lightSkeleton ? styles['s3-image-wrapper__skeleton--light'] : '',
	];

	return (
		<div className={wrapperClasses.join(' ')}>
			{isLoading && <Skeleton className={skeletonClasses.join(' ')} />}
		</div>
	);
};
